export default "__VITE_ASSET__CDlQ5C5m__"